module.exports = __webpack_public_path__ + "static/img/hammer.846aa4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xiangyun/hammer.png
// module id = oXEz
// module chunks = 1